import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-rolle-entfernen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichRolleEntfernenEffects {

    BereichRolleEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_ROLLE_ENTFERNEN),
        mergeMap((x: ac.PostBereichRolleEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichRolleEntfernen(x.bereichRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichRolleEntfernenErfolgreichAction(result, x.bereichRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichRolleEntfernenFehlerAction(error, x.bereichRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
